import { BASE } from './index';
import axios from './http';

const ranking = {
    //车辆排位图列表
    vehicleLayoutlist: params => axios.post(`${BASE.PRO2}/vehicleLayout/list`, params),
    //车辆排位图列表查看自提点所在位置
    vehicleLayoutsearchlabel: params => axios.post(`${BASE.PRO2}/vehicleLayout/search/label`, params),
    //车辆排位图保存排位数据
    vehicleLayoutstore: params => axios.post(`${BASE.PRO2}/vehicleLayout/store`, params),
    //车辆排位图待排位的城市仓
    vehicleLayoutlogisticslist: params => axios.post(`${BASE.PRO2}/vehicleLayout/logistics/list`, params),
    //车辆排位图待排位的自提点
    vehicleLayoutdeliverylist: params => axios.post(`${BASE.PRO2}/vehicleLayout/delivery/list`, params),
    //车辆排位图排位图清除数据
    vehicleLayoutlistclear: params => axios.post(`${BASE.PRO2}/vehicleLayout/list/clear`, params),
    //车辆排位图漏排筛查
    vehicleLayoutnoarrangetdc: params => axios.post(`${BASE.PRO2}/vehicleLayout/no/arrange/tdc`, params),
    //车辆排位图漏排筛查
    vehicleLayoutchecklist: params => axios.post(`${BASE.PRO2}/vehicleLayout/check/list`, params),
    //自采车辆排位图列表
   selfvehicleLayoutlist: params => axios.post(`${BASE.PRO2}/self/vehicleLayout/list`, params),
    //自采车辆排位图列表车位名称
   vehicleLayoutflagname: params => axios.post(`${BASE.PRO2}/self/vehicleLayout/flag/name`, params),
    //自采车辆排位图列表
   logisticslist: params => axios.post(`${BASE.PRO2}/self/vehicleLayout/logistics/list`, params),
    //自采车辆排位图列表车位名称
   deliverylist: params => axios.post(`${BASE.PRO2}/self/vehicleLayout/delivery/list`, params),
    //自采车辆排位图列表车位名称
   vehicleLayoutclear: params => axios.post(`${BASE.PRO2}/self/vehicleLayout/list/clear`, params),
    //自采车辆排位图列表车位名称
   selfvehicleLayoutstore: params => axios.post(`${BASE.PRO2}/self/vehicleLayout/store`, params),
    //自采车辆排位图列表车位名称
   vehicleLayoutlabelname: params => axios.post(`${BASE.PRO2}/self/vehicleLayout/label/name`, params),

};

export default ranking;
